import { useAuth } from '@/hooks/use-auth'
import { useProfile } from '@/hooks/use-profile'
import { useAccountIdentity } from '@/hooks/use-account-identity'
import { getPersonDisplayMeta } from '@/lib/person-identity-display'

export type AccountMenuIdentity = {
  personName: string
  formalName: string
  email: string
  primaryLabel: string
  avatarUrl: string | null | undefined
  avatarColorSeed: string
}

/** Shared display identity for sidebar and marketing account menus. */
export function useAccountMenuIdentity(): AccountMenuIdentity {
  const { user } = useAuth()
  const { profile } = useProfile()
  const { identity } = useAccountIdentity()

  const meta = getPersonDisplayMeta({
    name: identity?.name ?? profile?.name,
    greeting_name: identity?.greeting_name ?? profile?.greeting_name,
    first_name: user?.first_name ?? profile?.first_name,
    last_name: user?.last_name ?? profile?.last_name,
    full_name: profile?.full_name,
    email: identity?.email ?? user?.email ?? profile?.email,
    id: profile?.id ?? user?.id ?? user?.email,
    avatar_url: identity?.avatar_url ?? profile?.avatar_url,
  })

  const email = (identity?.email ?? user?.email ?? profile?.email ?? '').trim()
  const primaryLabel = meta.displayName || email || 'Account'

  return {
    personName: meta.displayName,
    formalName: meta.formalName,
    email,
    primaryLabel,
    avatarUrl: identity?.avatar_url ?? profile?.avatar_url,
    avatarColorSeed: meta.colorSeed || email || primaryLabel,
  }
}
